import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthSigninModule } from './auth-signin/auth-signin.module';
import { AuthForgotPssModule } from './auth-forgot-pss/auth-forgot-pss.module';
import { AuthNewPasswordModule } from './auth-new-password/auth-new-password.module';
import { HomeModule } from './home/home.module';
import { SharedModule } from './shared/shared.module';
import { CompaniesModule } from './companies/companies.module';
import { SellersModule } from './sellers/sellers.module';
import { StoresModule } from './stores/stores.module';
import { OrdersModule } from './orders/orders.module';
import { BuyersModule } from './buyers/buyers.module';
import { StepsModule } from './steps/steps.module';
import { UnpaidModule } from './unpaid/unpaid.module';
import { ArchivedCompaniesModule } from './archived-companies/archived-companies.module';
import { ReportModule } from './report/report.module';
import { BuyerDetailsModule } from './buyer-details/buyer-details.module';
import { CompanyDetailsModule } from './company-details/company-details.module';
import { OrderDetailsModule } from './order-details/order-details.module';
import { SellerDetailsModule } from './seller-details/seller-details.module';
import { StoreDetailsModule } from './store-details/store-details.module';
import { ScriptsModule } from './scripts/scripts.module';
import { VopRequestModule } from './vop-request/vop-request.module';
import { SettingsModule } from './settings/settings.module';
import { ProductCategoryModule } from './product-category/product-category.module';
import { ProductSubcategoryModule } from './product-subcategory/product-subcategory.module';
import { ClusterModule } from './cluster/cluster.module';

import { MatDialogModule } from '@angular/material/dialog';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { AuthMfaModule } from './auth-mfa/auth-mfa.module';
import { PendingInvitationsModule } from './pending-invitations/pending-invitations.module';

registerLocaleData(localeIt);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?cb=' + new Date().getTime());
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthSigninModule,
    AuthNewPasswordModule,
    AuthForgotPssModule,
    HomeModule,
    CompaniesModule,
    SellersModule,
    PendingInvitationsModule,
    StoresModule,
    OrdersModule,
    BuyersModule,
    StepsModule,
    SharedModule,
    UnpaidModule,
    AuthMfaModule,
    ArchivedCompaniesModule,
    ReportModule,
    BuyerDetailsModule,
    CompanyDetailsModule,
    OrderDetailsModule,
    SellerDetailsModule,
    StoreDetailsModule,
    ScriptsModule,
    VopRequestModule,
    SettingsModule,
    ProductCategoryModule,
    ProductSubcategoryModule,
    ClusterModule,
    HttpClientModule,
    MatDialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [DatePipe, DecimalPipe, { provide: LOCALE_ID, useValue: 'it-IT' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
